export const CHECK_INTERVAL_MS = 5_000;
export const SESSION_START_KEY = 'session_absolute_start';

export const ACTIVITY_EVENTS = ['click', 'keydown', 'scroll', 'mousemove', 'touchstart'] as const;
export const THROTTLE_MS = 1_000;

